import React from "react";
import { Zap, BadgeEuro, ShieldCheck, MessageSquarePlus } from "lucide-react";

const POINTS = [
  { icon: Zap, title: "Simple", text: "Vous démarrez en quelques minutes, sans formation." },
  { icon: BadgeEuro, title: "Transparent", text: "Tarifs affichés, un plan gratuit pour votre premier bien." },
  { icon: ShieldCheck, title: "Vos données vous appartiennent", text: "Export de vos données à tout moment · hébergement en France." },
];

export default function WhyChoose() {
  return (
    <section id="pourquoi" className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-5 lg:px-8">
        <div className="text-center mb-14 max-w-2xl mx-auto">
          <p className="text-brand-limeDark font-semibold mb-3">Pourquoi 360immoinvest ?</p>
          <h2 className="font-display text-4xl lg:text-5xl font-semibold text-brand-greenDeep">Pensé pour les bailleurs particuliers</h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {POINTS.map((p) => (
            <div key={p.title} className="rounded-3xl bg-brand-softer p-8 border border-brand-soft">
              <div className="w-12 h-12 rounded-2xl bg-brand-lime/30 text-brand-greenDeep flex items-center justify-center"><p.icon className="w-6 h-6" /></div>
              <p className="font-display text-xl font-semibold text-brand-greenDeep mt-4">{p.title}</p>
              <p className="mt-2 text-brand-green/70 leading-relaxed">{p.text}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 rounded-3xl bg-brand-green p-8 text-center">
          <MessageSquarePlus className="w-8 h-8 text-brand-lime mx-auto mb-3" />
          <p className="text-white text-lg font-medium">Vous êtes bailleur et avez testé le logiciel ?</p>
          <p className="text-white/60 mt-1">Donnez-nous votre avis — vos retours nous aident à l'améliorer.</p>
        </div>
      </div>
    </section>
  );
}
